export default "__VITE_ASSET__79b754f4__"